export const menu = {
  tableCol: {
    no: { en: 'No.', ko: '번호', fr: '' },
    name: { en: 'Name', ko: '이름', fr: '' },
    routeInfo: { en: 'ROUTE INFO', ko: '라우트 정보', fr: '' },
    sortValue: { en: 'Sort value', ko: '순서 값', fr: '' },
  },
  info: {
    name: { en: 'Name', ko: '이름', fr: '' },
    level: { en: 'Level', ko: 'Level', fr: '' },
    routeInfo: { en: 'ROUTE INFO', ko: '라우트 정보', fr: '' },
    iconFileID: { en: 'Icon file ID', ko: 'Icon file ID', fr: '' },
    sortValue: { en: 'Sort value', ko: '순서 값', fr: '' },
  },
};
